import { DocumentTemplateType } from '../../../models/applications/application-documents';
import { Contract } from '../../../models/applications/contracts';
import { applicationDocumentsApi } from '../../../redux/api/applications/application-documents-api';
import { downloadFile } from '../../../utils/common';

export const useDownloadMaternalCapitalSupplementalDocument = () => {
  const [generateDocument] =
    applicationDocumentsApi.useLazyGenerateDocumentQuery();

  return (contract: Contract) => {
    generateDocument({
      id: Number(contract.id),
      docType: DocumentTemplateType.MATERNAL_CAPITAL_SUPPLEMENTAL,
    })
      ?.unwrap()
      .then(result => {
        downloadFile(
          new File(
            [result],
            'ДС об оплате за счет средств МСК_' + contract.number + '.docx'
          )
        );
      });
  };
};
